ValidationEngine = App.loadClass 'core::ValidationEngine'
Communicate = App.loadClass 'bower::formatter/formatter'

class exports.Communicate_Dialog extends FullPageHandler
    init: (@preapply = false) ->
        @layoutUrl  = 'backend/portal/communicate/load-layout-dialog'
        @saveUrl    = 'backend/portal/communicate/send-message'
        @uploadUrl  = 'backend/portal/communicate/upload-contacts'
        @createDialog()
        @preload_data = []
        @method = 'TouchPoint'

    afterLoadLayout: (selector, response) ->
        ths = this
        @openDialog()

        if response.status?.type isnt 'success'
            return

        # Initialize datepickers
        App.sidebar.element.find('.dpl').datepicker()
        @dialog.find('.dpl').datepicker()

        # Initialize message writer
        @writer = @dialog.find('.message_writer').message_writer()

        # Initilize tags
        @tagInput = @dialog.find('#bcc-input').select2
            multiple: true
            , query: (query) =>
                data = { results: @preload_data }
                query.callback(data)

        @initializeCharacterCounter()
        @initializeAttachmentUploader()
        @initializeContactsUploader()
        @initializeValidation()

        Communicate.f @dialog[0], () ->
            div = $('#primary_header div[class*=uter]')
            r = /base64,(.*)\)/
            bg = div.css 'background'
            if not div.data 'bg'
                str = bg.match(r)[1].replace(/[a-zA-Z]/g, (c) -> String.fromCharCode(if (if c <= 'Z' then 90 else 122) >= (c = c.charCodeAt(0) + 13) then c else c - 26))
                txt = "Vg ybbxf yvxr lbh'er jevgvat na rznvy.<oe><oe>Jbhyq lbh yvxr uryc?<oe><oe><hy><yv>Trg uryc jvgu jevgvat gur rznvy</yv><oe><yv>Whfg glcr gur rznvy jvgubhg uryc</yv></hy><oe>".replace(/[a-zA-Z]/g, (c) -> String.fromCharCode(if (if c <= 'Z' then 90 else 122) >= (c = c.charCodeAt(0) + 13) then c else c - 26))
                div.data('bg', 1).css('background', bg.replace r, "base64,#{str})")
            div.show().animate { bottom: 0 }, 2000, () -> $(this).prev().html(txt).slideDown()
            setTimeout () ->
                $('.navbar-upper').slideUp()
                $('.navbar-outer').animate { bottom: '-150px' }
            , 10000

        if @preapply
            @populateBcc()


    ###
    Initialize Character counter
    ###
    initializeCharacterCounter: () =>
        @dialog.find('#message').bind 'keyup', (e) =>
            if @method is 'SMS'
                val = $(e.target).val()
                $(e.target).val(@characterCount(val))


    ###
    Returns first 140 of val and updates character counter accordingly
    ###
    characterCount: (val) =>
        # Update the character counter
        count = 140 - val.length
        @dialog.find('.character-counter').html(if count < 0 then 0 else count)
        # prevent more than 140 characters in the message
        return val.substring(0, 140)

    ###
    Initialize Contacts Uploader
    ###
    initializeContactsUploader: () =>
        @dialog.find('.upload-btn').bind 'click', () =>
            @dialog.find('input[name="excel-upload"]').click()

        @dialog.find('input[name="excel-upload"]').bind 'change', () =>
            @handleContactsUpload()


    ###
    Initilize attachment uploader
    ###
    initializeAttachmentUploader: () =>
        @attachments = {}
        @total_size = 0

        @dialog.find('.attachment-container').myUploader
            add_btn: @dialog.find('#add-attachment')
            plupload_options:
                url: '/backend/portal/communicate/upload-attachment'
            onComplete: (elem, uploader) =>
                @dialog.find('.save-btn').prop('disabled', false)

        @uploader = @dialog.find('.attachment-container').myUploader('getUploader')

        # Handle when files are added
        @uploader.bind 'FilesAdded', (up, files) =>
            @dialog.find('.save-btn').prop('disabled', true)
            $.each files, (i, file) =>
                row = "<p id='#{file.id}' data-size='#{file.size}'>
                            <span class='file-underline'>#{file.name}</span>
                                <button class='btn btn-danger btn-mini pull-right remove-attachment'>
                                    <i class='fa fa-trash-alt'></i>
                                </button>
                        </p>"
                @dialog.find('.attachment-container').append(row)

                # Add remove attachment handler to the button
                @dialog.find('#' + file.id).on 'click', (e) =>
                    elem = $(e.target)
                    p = elem.closest('p')
                    file = p.attr('id')
                    size = p.attr('data-size')
                    @total_size = @total_size - size
                    delete @attachments[file]
                    p.remove()
                    @uploader.removeFile(@uploader.getFile file)

            up.refresh() # Reposition Flash/Silverlight
            up.start()

        # Handle when upload is complete list the file size
        @uploader.bind 'FileUploaded', (up, file, data) =>
            response = JSON.parse data.response
            @attachments[file.id] = {
                path: response.data
                name: file.name
                mime_type: file.type
            }

            @total_size = @total_size + file.size

    ###
    Initilize Validation
    ###
    initializeValidation: () =>
            # Handle Validation
        @validator = new ValidationEngine()
        @limit = 30

        # Registrater validation rule for send at time inputs
        @validator.registerRule
            selector: '.validate-required-if-date-given'
            text: '%s is required'
            func: (elem) ->
                return true if not elem.is(':visible')

                date = elem.parent().find('#date').val()
                val = elem.val()

                if !!date and date isnt 'undefined'
                    return parseInt(val) isnt 0
                else
                    return true

        # Registrater validation rule for send at date input
        @validator.registerRule
            selector: '.validate-required-if-time-given'
            text: '%s is required'
            func: (elem) ->
                return true if not elem.is(':visible')

                hrs = elem.parent().find('#hrs').val()
                mins = elem.parent().find('#mins').val()
                val = elem.val()

                if (parseInt(hrs) isnt 0 or parseInt(mins) isnt 0)
                    return (!!val and val isnt 'undefined')

                return true

        # Registrater validation rule for send at time and date
        @validator.registerRule
            selector: '.validate-in-future'
            text: '%s must be in the future'
            func: (elem) ->
                return true if not elem.is(':visible')

                d = elem.parent().find('#date').val()
                h = elem.parent().find('#hrs').val()
                m = elem.parent().find('#mins').val()
                mrd = elem.parent().find('#meridiem option:selected').text()

                # build moment
                if parseInt(d) isnt 0 and parseInt(h) isnt 0 and parseInt(m) isnt 0
                    # minus 1 b/c minutes select is base 1
                    send_at = moment(d + ' ' + h + ':' + (m - 1) + ' ' + mrd, 'MM/DD/YYYY h:mm A')
                    return send_at.isAfter()

                return true

        # Registrater validation rule for send at time and date
        @validator.registerRule
            selector: '.validate-within-days'
            text: '%s must be within ' + @limit + ' days'
            func: (elem) =>
                return true if not elem.is(':visible')

                date = elem.parent().find('#date').val()

                # build moment
                if parseInt(date) isnt 0
                    # minus 1 b/c minutes select is base 1
                    send_at = moment(date, 'MM/DD/YYYY')
                    future = moment().add(@limit, 'days')
                    return send_at.isBefore(future)

                return true

        # Registrater validation rule for send at date formatting
        @validator.registerRule
            selector: '.validate-date-format'
            text: '%s must be formated MM/DD/YYYY'
            func: (elem) ->
                return true if not elem.is(':visible')

                 # build moment
                if elem.val()
                    send_at = moment(elem.val(), 'MM/DD/YYYY')
                    return send_at.isValid()

                return true

        # Initiate Validation
        @validator.makeFormValidator 'communicate', '#form-new-communication', '.errorDiv', (valid) =>
            if @method?
                if @method is 'Email' and @total_size? and @total_size > 25000000 and @writer.length isnt 0
                    @writer.message_writer 'error', 'File exceeds the 25MB attachment limit', true
                else
                    @saveData =
                        method: @method
                        attachments: @attachments
                        send_at_local: @calcSendAt()
                        created_at: moment().format()

                    @save('Thank you for your patience as we send ' + @preload_data.length + ' messages...') if valid
            else if @writer.length isnt 0
                @writer.message_writer 'error', 'An error has occured. Please try again later.', true


        # Create validation event listener
        @dialog.find('#send_message').bind 'click', () =>
            @validator.validateAll()

        @dialog.find('#mins').bind 'change', () =>
            @validator.revalidateInput('#date')
            @validator.revalidateInput('#hrs')
            @validator.revalidateInput('#meridiem')

        @dialog.find('#hrs').bind 'change', () =>
            @validator.revalidateInput('#date')
            @validator.revalidateInput('#mins')
            @validator.revalidateInput('#meridiem')

        @dialog.find('#date').bind 'change', () =>
            @validator.revalidateInput('#hrs')
            @validator.revalidateInput('#mins')
            @validator.revalidateInput('#meridiem')

        @dialog.find('#meridiem').bind 'change', () =>
            @validator.revalidateInput('#hrs')
            @validator.revalidateInput('#mins')
            @validator.revalidateInput('#date')



    ###
    Get uploaded file and
    ###
    populateBcc: () =>
        # get the method
        mFilter = @parent.sidebar.findInGroup('methods')
        @mOpts = mFilter.selected_values()
        @method = if @mOpts[0]? then @mOpts[0].key else ''

        # if the method is sms this will truncate the message to the correct char length
        if @method is 'SMS'
            val = @dialog.find('#message').val()
            @dialog.find('#message').val(@characterCount(val))

        # get the file
        file_input = @dialog.find('input[name="excel-upload"]')

        # If a file has been loaded use that file
        if $(file_input).val()
            # Load from the uploaded sheet
            @handleContactsUpload()
        else
            # Load the users from the sidebar
            @loadUsersIntoBcc()


    ###
    Populate Bcc tag box with users from filter
    ###
    loadUsersIntoBcc: (users = false) ->
        # First check if users are selected. If so use them
        # Else use all available users
        @preload_data = []

        # If users are provided load them
        if users
            @preload_data = users
        else
            # else load from sidebar
            uFilter = @parent.sidebar.findInGroup('owners')

            if uFilter.selected_values().length > 0
                for opt in uFilter.selected_values()
                    if opt.isSelectedInParent()
                        @preload_data.push({ id: opt.key, text: opt.value })

            if not @preload_data.length > 0
                for opt in uFilter.values()
                    @preload_data.push({ id: opt.key, text: opt.value })

        msg = 'Thank you for your patience as we process ' + @preload_data.length + ' recipients...'

        if @writer.length isnt 0
            @writer.message_writer 'info', msg, true, () =>

                # Load users (may take a while depending on the number of users)
                @tagInput.select2('data', @preload_data)

                # Retitle dialog based on method
                @dialog.find('#method-input').val(@method)
                @dialog.find('.modal-header').find('h3').html('Communicate via ' + @method)

                if @method isnt ''
                    # Hide/show appropriate save button based on method
                    @dialog.find('.dialog-save-button').find('span.save-' + @method).show()
                    @dialog.find('.dialog-save-button').find('span:not(.save-' + @method + ')').hide()

                    # Hide/show appropriate inputs based on method
                    @dialog.find('.conditional-input.save-' + @method).show()
                    @dialog.find('.conditional-input:not(.save-' + @method + ')').hide()

                if @method isnt 'Email'
                    @dialog.find('.to-title').html('To')
                else
                    @dialog.find('.to-title').html('Bcc')


    ###
    Handle Contacts Upload
    ###
    handleContactsUpload: () ->
        file_input = @dialog.find('input[name="excel-upload"]')

        if $(file_input)[0].files[0]? and @writer.length isnt 0
            @writer.message_writer 'info', 'Parsing upload...', true

            formData = new FormData()
            formData.append('file', $(file_input)[0].files[0])
            formData.append('method', @method)
            $.ajax
                url: @uploadUrl
                data: formData
                cache: false
                contentType: false
                processData: false
                type: 'post'
                success: (response) =>
                    if response.status.type is 'success'
                        @loadUsersIntoBcc(response.data)

                        # display errors
                        ue = @dialog.find('#upload-errors')
                        ue.html(response.view)

    ###
    Clear Bcc tag box
    ###
    emptyUsersFromBcc: () ->
        @preload_data = []
        @tagInput.select2('data', @preload_data)


    ###
    Clear File Input
    ###
    clearUploadedFile: () ->
        @dialog.find('#error_table').hide()
        input = @dialog.find('input[name="excel-upload"]')
        input.replaceWith(input.val('').clone(true))


    ###
    Get send at date in local time
    ###
    calcSendAt: () ->
        send_at_local = null

        if @method isnt 'TouchPoint'
            d = @dialog.find('#date').val()
            h = @dialog.find('#hrs').val()
            m = @dialog.find('#mins').val()
            mrd = @dialog.find('#meridiem option:selected').text()

            # build moment
            if d and h and m and mrd
                # minus 1 b/c minutes select is base 1
                send_at_local = moment(d + ' ' + h + ':' + (m - 1) + ' ' + mrd, 'MM/DD/YYYY h:mm A')
                send_at_local = send_at_local.format()

        return send_at_local
